<template>
  <div class="wrapper">
    <cabecalho :tituloPagina="formulario.emitente.id ? 'Editar Emitente' : 'Novo Emitente'" />
    <menuLateral />

    <div class="content-wrapper">

      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6"></div>
          </div>
        </div>
      </section>

      <section class="content">
        <div class="card">

          <div class="card-body">

            <spinnerProcessando
              cssClass="ml-2"
              :status="desabilitarCampos"
              :mensagem="flagsDeControle.carregandoDados.mensagem || flagsDeControle.manipulandoDados.mensagem"
            />

            <div v-if="situacaoCadastroFiscal" class="avisoDanger col-12 mb-2">{{ situacaoCadastroFiscal }}</div>

            <div v-if="!flagsDeControle.carregandoDados.status" class="row">

              <!-- MENU ABAS -->
              <div class="col-4 col-sm-3 col-xl-2">
                <nav class="nav nav-pills flex-column nav-tabs h-100"
                    id="vert-tabs-tab"
                    role="tablist"
                    aria-orientation="vertical">

                  <a class="nav-link active"
                    id="vert-tabs-emitente-tab"
                    data-toggle="pill"
                    href="#vert-tabs-emitente"
                    role="tab">
                    <b>Configurações do Emitente</b> <i v-if="flagAbas.emitente" class="fas fa-exclamation-triangle"></i>
                  </a>

                  <a class="nav-link"
                    id="vert-tabs-servico-tab"
                    data-toggle="pill"
                    href="#vert-tabs-servico"
                    role="tab">
                    <b>Configuração do Serviço</b> <i v-if="flagAbas.servico" class="fas fa-exclamation-triangle"></i>
                  </a>

                  <a class="nav-link" data-toggle="pill" href="#vert-tabs-endereco" role="tab"><b>Endereço</b> <i v-if="flagAbas.endereco" class="fas fa-exclamation-triangle"></i></a>
                  <a class="nav-link" data-toggle="pill" href="#vert-tabs-contato" role="tab"><b>Contato</b> <i v-if="flagAbas.contato" class="fas fa-exclamation-triangle"></i></a>
                  <a class="nav-link" data-toggle="pill" href="#vert-tabs-tributos" role="tab"><b>Tributos</b> <i v-if="flagAbas.tributos" class="fas fa-exclamation-triangle"></i></a>
                  <a class="nav-link" data-toggle="pill" href="#vert-tabs-config" role="tab" @click="abrirAbaLogotipo()"><b>Certificado e DANFe</b> <i v-if="flagAbas.config" class="fas fa-exclamation-triangle"></i></a>
                  <a class="nav-link" data-toggle="pill" href="#vert-tabs-responsavel" role="tab"><b>Responsável</b> <i v-if="flagAbas.responsavel" class="fas fa-exclamation-triangle"></i></a>

                </nav>
              </div>

              <!-- CONTEUDO -->
              <div class="col-8 col-sm-9 col-xl-10">

                <div class="tab-content" id="vert-tabs-tabContent">

                  <!-- ABA EMITENTE -->
                  <div class="tab-pane fade show active"
                      id="vert-tabs-emitente"
                      role="tabpanel">

                    <div class="row">

                      <div class="form-group col-md-12 col-lg-6 col-xl-6">
                        <label>Tipo de Pessoa</label>
                        <select class="form-control" v-model.number="formulario.emitente.tipo" :disabled="desabilitarCampos || documentoBloqueado">
                          <option :value="2">Pessoa Jurídica</option>
                          <option :value="1">Pessoa Física</option>
                        </select>
                      </div>

                      <div class="form-group col-md-12 col-lg-6 col-xl-6">
                        <label class="required">Razão Social</label>
                        <input type="text" class="form-control"
                              v-model="formulario.emitente.razao_social" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.razao_social">{{ dadosRetorno.listaDeErros.razao_social }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-6 col-xl-6" v-if="ehPessoaJuridica">
                        <label class="required">CNPJ</label>
                        <input type="text"
                          class="form-control campo-DocumentoCpfCnpjAlfanumericoUppercase"
                          v-mask="mascaraCnpj(formulario.emitente.cnpj)"
                          v-model="formulario.emitente.cnpj"
                          maxlength="18" @change="verificarDocumento()" :disabled="desabilitarCampos || documentoBloqueado">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.cnpj">{{ dadosRetorno.listaDeErros.cnpj }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-6 col-xl-6" v-if="ehPessoaJuridica">
                        <label>Nome Fantasia</label>
                        <input type="text" class="form-control" v-model="formulario.emitente.nome_fantasia" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.nome_fantasia">{{ dadosRetorno.listaDeErros.nome_fantasia }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-6 col-xl-6" v-if="ehPessoaFisica">
                        <label class="required">CPF</label>
                        <input type="text" class="form-control" v-mask="mascaraCpf(formulario.emitente.cpf)" v-model="formulario.emitente.cpf" maxlength="14" @change="verificarDocumento()" :disabled="desabilitarCampos || documentoBloqueado">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.cpf">{{ dadosRetorno.listaDeErros.cpf }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-4 col-xl-4">
                        <label>Inscrição Municipal</label>
                        <input type="text" class="form-control"
                              v-model="formulario.emitente.inscricao_municipal" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.inscricao_municipal">{{ dadosRetorno.listaDeErros.inscricao_municipal }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-4 col-xl-4">
                        <label>Inscrição Estadual</label>
                        <input type="text" class="form-control" maxlength="20"
                              v-model="formulario.emitente.inscricao_estadual" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.inscricao_estadual">{{ dadosRetorno.listaDeErros.inscricao_estadual }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-4 col-xl-4">
                        <label class="required">Regime Tributário</label>
                        <select class="form-control"
                                v-model="formulario.emitente.regime_tributario" :disabled="desabilitarCampos">
                          <option value="">Selecione</option>
                          <option value="1">Simples Nacional</option>
                          <option value="2">Simples Nacional - Excesso de sublimite de receita bruta</option>
                          <option value="3">Regime Normal</option>
                          <option value="4">Simples Nacional - MEI</option>
                        </select>
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.regime_tributario">{{ dadosRetorno.listaDeErros.regime_tributario }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-4 col-xl-4">
                        <label class="required">Incentivador Cultural</label>
                        <select class="form-control"
                                v-model="formulario.emitente.incentivador_cultural" :disabled="desabilitarCampos">
                          <option value="">Selecione</option>
                          <option :value="true">Sim</option>
                          <option :value="false">Não</option>
                        </select>
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.incentivador_cultural">{{ dadosRetorno.listaDeErros.incentivador_cultural }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-4 col-xl-4">
                        <label class="required">Optante Simples Nacional</label>
                        <select class="form-control"
                                v-model="formulario.emitente.optante_simples_nacional" :disabled="desabilitarCampos">
                          <option value="">Selecione</option>
                          <option :value="true">Sim</option>
                          <option :value="false">Não</option>
                        </select>
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.optante_simples_nacional">{{ dadosRetorno.listaDeErros.optante_simples_nacional }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-4 col-xl-4">
                        <label class="required">ISS Retido</label>
                        <select class="form-control"
                                v-model="formulario.emitente.iss_retido" :disabled="desabilitarCampos">
                          <option value="">Selecione</option>
                          <option :value="true">Sim</option>
                          <option :value="false">Não</option>
                        </select>
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.iss_retido">{{ dadosRetorno.listaDeErros.iss_retido }}</div>
                      </div>

                    </div>

                  </div>

                  <!-- ABA SERVIÇO -->
                  <div class="tab-pane fade"
                      id="vert-tabs-servico"
                      role="tabpanel">

                    <div class="row">

                      <div class="form-group col-md-12 col-lg-6 col-xl-6">
                        <label class="required">Código de tributação nacional do ISSQN</label>
                        <input type="text" class="form-control"
                              v-model="formulario.servico.codigo_issqn" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.codigo_tributacao_nacional_issqn">{{ dadosRetorno.listaDeErros.codigo_tributacao_nacional_issqn }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-6 col-xl-6">
                        <label class="required">CNAE</label>
                        <input type="text" class="form-control"
                              v-model="formulario.servico.cnae" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.codigo_cnae">{{ dadosRetorno.listaDeErros.codigo_cnae }}</div>
                      </div>

                      <div class="form-group col-md-12 col-lg-6 col-xl-6">
                        <label class="required">Regime Especial de Tributação</label>
                        <select class="form-control"
                                v-model="formulario.servico.regime_especial" :disabled="desabilitarCampos">
                          <option value="0">Nenhum</option>
                          <option value="1">Ato Cooperado (Cooperativa)</option>
                          <option value="2">Estimativa</option>
                          <option value="3">Microempresa Municipal</option>
                          <option value="4">Notário ou Registrador</option>
                          <option value="5">Profissional Autônomo</option>
                          <option value="6">Sociedade de Profissionais</option>
                          <option value="9">Outros</option>
                        </select>
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.regime_especial_tributacao_municipal">{{ dadosRetorno.listaDeErros.regime_especial_tributacao_municipal }}</div>
                      </div>

                    </div>

                  </div>

                  <!-- ABA ENDEREÇO -->
                  <div class="tab-pane fade" id="vert-tabs-endereco" role="tabpanel">
                    <div class="row">
                      <div class="form-group col-md-12 col-lg-4">
                        <label class="required">CEP</label>
                        <input type="text" class="form-control" v-mask="mascaraCep(formulario.endereco.cep)" v-model="formulario.endereco.cep" @blur="consultarCep()" maxlength="9" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.cep">{{ dadosRetorno.listaDeErros.cep }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label class="required">Logradouro</label>
                        <input type="text" class="form-control" v-model="formulario.endereco.logradouro" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.logradouro">{{ dadosRetorno.listaDeErros.logradouro }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-2">
                        <label class="required">Número</label>
                        <input type="text" class="form-control" v-model="formulario.endereco.numero" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.numero">{{ dadosRetorno.listaDeErros.numero }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label>Complemento</label>
                        <input type="text" class="form-control" v-model="formulario.endereco.complemento" :disabled="desabilitarCampos">
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label class="required">Bairro</label>
                        <input type="text" class="form-control" v-model="formulario.endereco.bairro" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.bairro">{{ dadosRetorno.listaDeErros.bairro }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label class="required">Município</label>
                        <input type="text" class="form-control" v-model="formulario.endereco.municipio" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="erroMunicipio">{{ erroMunicipio }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-2">
                        <label class="required">UF</label>
                        <b-form-select v-model="formulario.endereco.uf" :options="comboUf" value-field="f_code" text-field="f_name" class="form-control comboFonteDefault" :disabled="desabilitarCampos"/>
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.uf">{{ dadosRetorno.listaDeErros.uf }}</div>
                      </div>
                      <input type="hidden" v-model="formulario.endereco.codigo_ibge">
                    </div>
                  </div>

                  <!-- ABA CONTATO -->
                  <div class="tab-pane fade" id="vert-tabs-contato" role="tabpanel">
                    <div class="row">
                      <div class="form-group col-md-12 col-lg-6">
                        <label>Telefone</label>
                        <TelefoneInput v-model="formulario.contato.telefone" class="form-control" :mask="mascaraTelefone(formulario.contato.telefone)" :disabled="desabilitarCampos"/>
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.telefone">{{ dadosRetorno.listaDeErros.telefone }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label>E-mail</label>
                        <input type="email" class="form-control" v-model="formulario.contato.email" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.email">{{ dadosRetorno.listaDeErros.email }}</div>
                      </div>
                    </div>
                  </div>

                  <!-- ABA TRIBUTOS -->
                  <div class="tab-pane fade" id="vert-tabs-tributos" role="tabpanel">
                    <div class="row">
                      <div class="form-group col-md-12 col-lg-4">
                        <label class="required">% Tributos Federais</label>
                        <input type="number" min="0" max="100" step="0.01" class="form-control" v-model="formulario.tributos.federais" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.percentual_tributos_federais">{{ dadosRetorno.listaDeErros.percentual_tributos_federais }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label class="required">% Tributos Estaduais</label>
                        <input type="number" min="0" max="100" step="0.01" class="form-control" v-model="formulario.tributos.estaduais" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.percentual_tributos_estaduais">{{ dadosRetorno.listaDeErros.percentual_tributos_estaduais }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label class="required">% Tributos Municipais</label>
                        <input type="number" min="0" max="100" step="0.01" class="form-control" v-model="formulario.tributos.municipais" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.percentual_tributos_municipais">{{ dadosRetorno.listaDeErros.percentual_tributos_municipais }}</div>
                      </div>
                    </div>
                  </div>

                  <!-- ABA CERTIFICADO E DANFE -->
                  <div class="tab-pane fade" id="vert-tabs-config" role="tabpanel">
                    <div class="row">
                      <div class="form-group col-md-12 col-lg-6">
                        <label>CPF/CNPJ da Contabilidade</label>
                        <input type="text" class="form-control" v-mask="mascaraDocumentoIdentificacao(formulario.configuracoes.cpf_cnpj_contabilidade)" v-model="formulario.configuracoes.cpf_cnpj_contabilidade" maxlength="18" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.cpf_cnpj_contabilidade">{{ dadosRetorno.listaDeErros.cpf_cnpj_contabilidade }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label>Certificado (PFX/P12)</label>
                        <UploadFile uploadFileRef="emitenteCertificado" accept=".pfx,.p12" @input="receberCertificado" :disabled="desabilitarCampos" />
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.certificado">{{ dadosRetorno.listaDeErros.certificado }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label>Senha do Certificado</label>
                        <input type="password" autocomplete="new-password" class="form-control" v-model="formulario.configuracoes.senha_certificado" :disabled="desabilitarCampos">
                        <small class="text-muted">Exigida somente quando você anexa um certificado.</small>
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.senha_certificado">{{ dadosRetorno.listaDeErros.senha_certificado }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label>Logotipo (PNG)</label>
                        <UploadLogotipo ref="uploadLogotipoEmitente" uploadFileRef="emitenteLogotipo" :codigoImagem="logotipoImagem" @input="receberLogotipo" :disabled="desabilitarCampos" />
                        <b-form-checkbox v-if="formulario.configuracoes.possui_logotipo" :checked="removerLogotipo" @change="alternarRemocaoLogotipo">Remover logo</b-form-checkbox>
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.logotipo">{{ dadosRetorno.listaDeErros.logotipo }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label>Exibe recibo na DANFe</label>
                        <select class="form-control" v-model="formulario.configuracoes.recibo_danfe" :disabled="desabilitarCampos"><option :value="true">Sim</option><option :value="false">Não</option></select>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label>Imprime colunas do IPI</label>
                        <select class="form-control" v-model="formulario.configuracoes.exibe_sempre_ipi_danfe" :disabled="desabilitarCampos"><option :value="true">Sim</option><option :value="false">Não</option></select>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label>Mostra dados do ISSQN</label>
                        <select class="form-control" v-model="formulario.configuracoes.exibe_issqn_danfe" :disabled="desabilitarCampos"><option :value="true">Sim</option><option :value="false">Não</option></select>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label>Imprime impostos adicionais</label>
                        <select class="form-control" v-model="formulario.configuracoes.exibe_impostos_adicionais_danfe" :disabled="desabilitarCampos"><option :value="true">Sim</option><option :value="false">Não</option></select>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label>Exibe rastreabilidade</label>
                        <select class="form-control" v-model="formulario.configuracoes.exibe_rastro_danfe" :disabled="desabilitarCampos"><option :value="true">Sim</option><option :value="false">Não</option></select>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label>Exibe unidade tributária</label>
                        <select class="form-control" v-model="formulario.configuracoes.exibe_unidade_tributaria_danfe" :disabled="desabilitarCampos"><option :value="true">Sim</option><option :value="false">Não</option></select>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label>Mostra sempre volumes</label>
                        <select class="form-control" v-model="formulario.configuracoes.exibe_sempre_volumes_danfe" :disabled="desabilitarCampos"><option :value="true">Sim</option><option :value="false">Não</option></select>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label>Ativação</label>
                        <select class="form-control" v-model="formulario.configuracoes.ativo" :disabled="desabilitarCampos"><option :value="true">Ativo</option><option :value="false">Inativo</option></select>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label>Habilitar NFS-e Nacional em produção</label>
                        <select class="form-control" v-model="formulario.configuracoes.habilita_nfsen_producao" :disabled="desabilitarCampos"><option :value="true">Sim</option><option :value="false">Não</option></select>
                      </div>
                      <div class="form-group col-md-12 col-lg-4">
                        <label>Habilitar NFS-e Nacional em homologação</label>
                        <select class="form-control" v-model="formulario.configuracoes.habilita_nfsen_homologacao" :disabled="desabilitarCampos"><option :value="true">Sim</option><option :value="false">Não</option></select>
                      </div>
                    </div>
                  </div>

                  <!-- ABA RESPONSÁVEL -->
                  <div class="tab-pane fade" id="vert-tabs-responsavel" role="tabpanel">
                    <div class="row">
                      <div class="form-group col-md-12 col-lg-6">
                        <label>Nome do Responsável</label>
                        <input type="text" class="form-control" v-model="formulario.responsavel.nome_responsavel" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.nome_responsavel">{{ dadosRetorno.listaDeErros.nome_responsavel }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label>CPF do Responsável</label>
                        <input type="text" class="form-control" v-mask="mascaraCpf(formulario.responsavel.cpf_responsavel)" v-model="formulario.responsavel.cpf_responsavel" maxlength="14" :disabled="desabilitarCampos">
                        <div class="avisoDanger" v-if="dadosRetorno.listaDeErros.cpf_responsavel">{{ dadosRetorno.listaDeErros.cpf_responsavel }}</div>
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label>Login da Prefeitura</label>
                        <input type="text" class="form-control" v-model="formulario.responsavel.login_responsavel" :disabled="desabilitarCampos">
                      </div>
                      <div class="form-group col-md-12 col-lg-6">
                        <label>Senha da Prefeitura</label>
                        <input type="password" autocomplete="new-password" class="form-control" v-model="formulario.responsavel.senha_responsavel" :disabled="desabilitarCampos">
                        <small v-if="formulario.responsavel.senha_responsavel_preenchida" class="text-muted">Senha já cadastrada — preencha apenas para alterar.</small>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

            </div>

          </div>
          <!-- FOOTER -->
          <div class="card-footer text-right">
            <b-button
              class="botoes ml-1"
              variant="outline-success btn-sm"
              :disabled="desabilitarCampos"
              @click="salvarEmitente()"
            >
              Salvar
            </b-button>

            <router-link to="/emitentes">
              <b-button
                class="botoes ml-1"
                variant="outline-primary btn-sm"
                :disabled="desabilitarCampos"
              >
                Voltar
              </b-button>
            </router-link>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import CadastroEmitente from './js/cadastro-emitente'
export default CadastroEmitente
</script>

<style scoped>
@import "./scss/edicao-emitente.scss";
</style>
